import { formatDenominatedNumber } from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';
import { ExpectedDistributionData } from './ExpectedDistributionData';
import { ComputedDistributionData } from './ComputedDistributionData';
import { SnapshotComparisonChart } from './SnapshotComparisonChart';

export const FullRewardDistribution = () => {
  const rewardDistribution = useSelector(
    (state: RootState) => state.rawVesta.rewardDistributionData
  );
  const farmData = useSelector((state: RootState) => state.rawVesta.config);
  return (
    <div className='accordion' id='accordionExample'>
      {rewardDistribution.status !== 'succeeded' ||
      rewardDistribution.data === null ? null : (
        <>
          <ExpectedDistributionData />
          <ComputedDistributionData />
        </>
      )}
      {farmData.status !== 'succeeded' || farmData.data === null ? null : (
        <SnapshotComparisonChart />
      )}
    </div>
  );
};
